<template>
  <div class="privacy-policy">
    PrivacyPolicy
  </div>
</template>
<script>


export default {
  name: 'PrivacyPolicy',
  data() {
    return {
    };
  },
  methods: {
  },
  created() {
  },
};
</script>
<style lang="less" scoped>
.privacy-policy {
}
</style>
